/**
 * Marketing Widgets
 * @type {Object}
 */
SITE.Marketing = {

    activeNow: "",

    freeConsoltTestfeb2019shown: false,


    init: function() {
        "use strict";

        var b = $("body");

        // If the user is logged in, don't do anything
        if (b.hasClass("logged-in")) return false;

        // Disable marketing if form is called by hash
        if (window.location.hash === "#contactModal") {
            SITE.Marketing.disable();
        }

        // Disable marketing if modal is opened
        $('a[data-toggle="modal"]').on('click', function() {
            SITE.Marketing.forceDisable();
        });

        // Check Cookie
        if (Cookies.get('sg-is-subscriber') === "true") {
            b.addClass("is-subscriber");
            SITE.Marketing.disable();
        }

        // Check for visitors form email
        if (SITE.Utils.getUrlParamByName("utm_medium") === 'email') {
            b.addClass("came-from-email");
        }
        
        // Only enable popups on desktop because of Google Update
        if (SITE.UI.viewport.mode != "xs" && SITE.UI.viewport.mode != "sm" ) {
            if ( SITE.Marketing.isEnabled() && ! $('body').hasClass('free-consult-test-feb2019') ) {
                //singleGrainConversionKit.ads.placeAds();
            }
        }

        //this.HeaderBar.init(); // It was disabled because it wasn't converting well
        
        if (!SITE.Utils.isBot()) {
            // Be careful what you put here
            // cos Google might not be too 
            // happy with showing it different 
            // contents
            //this.CallPop.init();    
        }

        // Exit intent for free consult page
        if($('body').hasClass('post-slug-free-consultation')) {

            // Detect Exit Intent
            if( SITE.UI.viewport.touch === true ) {

                // On touch devices use time trigger
                window.setTimeout(function() {
                    $("#contactModal").modal("show");
                }, 25000);

            } else {

                // On other devices use exit intent
                $(document).mouseleave(function(e){

                    // Did mouse go to the top?
                    if (e.clientY < 0) {
                        
                        // Has the user scrolled sufficiently?
                        if(500 < SITE.UI.viewport.scrollTop ) {
                            $("#contactModal").modal("show");
                        }
                    }

                });
            }

        }

        // Exit intent for AdvertiseCast initiative
        if($('body').hasClass('post-slug-the-ultimate-guide-to-podcast-advertising') || $('body').hasClass('post-slug-podcast-advertising-what-you-need-to-know')) {

            // Detect Exit Intent
            if( SITE.UI.viewport.touch === true ) {

                // On touch devices use time trigger
                window.setTimeout(function() {
                    $("#advertiseCastModal").modal("show");
                }, 25000);

            } else {

                // On other devices use exit intent
                $(document).mouseleave(function(e){

                    // Did mouse go to the top?
                    if (e.clientY < 0) {
                        
                        // Has the user scrolled sufficiently?
                        if(500 < SITE.UI.viewport.scrollTop ) {
                            $("#advertiseCastModal").modal("show");
                        }
                    }

                });
            }

        }

        // Exit intent for Feb 2019 test
        if( ! $('body').hasClass('postid-4798') && $('body').hasClass('free-consult-test-feb2019')) {

            $('.sg-content-upgrade').not('.sg-content-upgrade--free-consult-test-feb2019').hide();
            $('.sg-content-upgrade--free-consult-test-feb2019').show();

            // Detect Exit Intent
            if( SITE.UI.viewport.touch === true ) {

                // On touch devices use time trigger
                window.setTimeout(function() {
                    if( SITE.Marketing.freeConsoltTestfeb2019shown == false ) {
                        $("#freeConsultFeb2019Modal").modal("show");
                    }
                    SITE.Marketing.freeConsoltTestfeb2019shown = true;
                }, 25000);

            } else {

                // On other devices use exit intent
                $(document).mouseleave(function(e){

                    // Did mouse go to the top?
                    if (e.clientY < 0) {
                        
                        // Has the user scrolled sufficiently?
                        if(500 < SITE.UI.viewport.scrollTop ) {
                            if( SITE.Marketing.freeConsoltTestfeb2019shown == false ) {
                                $("#freeConsultFeb2019Modal").modal("show");
                            }
                            SITE.Marketing.freeConsoltTestfeb2019shown = true;
                        }
                    }

                });
            }

            $('#freeConsultFeb2019Modal .btn').on('click', function() {
                $("#freeConsultFeb2019Modal").modal("hide");
            });

            // Check if after some time class is there, if not, revert
            setTimeout(function() {
                if($('body').hasClass('revert-free-consult-test-feb2019')) {
                    SITE.Marketing.revertFeb2019FCTest();
                } else {
                    setTimeout(function() {
                        if($('body').hasClass('revert-free-consult-test-feb2019')) {
                            SITE.Marketing.revertFeb2019FCTest();
                        }
                    }, 2000);
                }
            }, 1000);

        }
        
    },

    revertFeb2019FCTest: function() {
        "use strict";

        $('.sg-content-upgrade').not('.sg-content-upgrade--free-consult-test-feb2019').show();
        $('.sg-content-upgrade--free-consult-test-feb2019').hide();

        SITE.Marketing.freeConsoltTestfeb2019shown = true;

        //singleGrainConversionKit.ads.placeAds();
    },

    /**
     * Check if Marketing is Enabled
     * ------------------------------
     *
     * Will be disabled if body has the following classes:
     * - is-subscriber
     * - conversion-page
     * 
     * @return {Boolean} [description]
     */
    isEnabled: function() {
        "use strict";

        var b = $("body");

        if(SITE.Marketing.isOnlyExitPop()) {
            return true;
        }

        //if (b.hasClass("is-subscriber") || b.hasClass("conversion-page")) return false;
        if (b.hasClass("conversion-page")) return false;
        else return true;
    },

    /**
     * Check if only exit pop is preferred.
     *
     * At the moment it's only the visitors that come from LinkedIn paid social.
     *
     * @return {Boolean}
     */
    isOnlyExitPop: function() {
        "use strict";

        var b = $("body"),
            utmMedium = SITE.Utils.getUrlParamByName('utm_medium'),
            utmSource = SITE.Utils.getUrlParamByName('utm_source');;

        if(utmSource == 'linkedin' && utmMedium == 'paid social') {

            // TODO: this is not a very elegant way to make an
            // exception, this should be refactored in future.
            if(b.hasClass('page-id-9541') || b.hasClass('page-id-9714')) { // production
            //if(b.hasClass('page-id-9447')) { // local    
                return true;
            }

        }

        return false;
    },

    /**
     * First visit check.
     *
     * Define if this is a first visit for the user.
     *
     * @return bool
     */
    isFirstVisit: function() {
        "use strict";

        // If at least one of these cookies are set, we assume that it's a not first visit
        if(typeof Cookies.get('sg-first-visit') != 'undefined') {
            return false;
        } else {
            Cookies.set('sg-first-visit', true, { expires: 1 }); // Once per day (same as Welcome mat)
        }

        if(typeof Cookies.get('sg-country') != 'undefined') {
            return false;
        }

        if(typeof Cookies.get('sg-is-subscriber') != 'undefined') {
            return false;
        }

        if(typeof Cookies.get('sg-welcome-mat-shown') != 'undefined') {
            return false;
        }

        if(typeof Cookies.get('sg-exit-pop-shown') != 'undefined') {
            return false;
        }

        if(typeof Cookies.get('sg-phone-pop-shown') != 'undefined') {
            return false;
        }

        return true;
    },

    /**
     * Disable All Marketing
     * @return {[type]} [description]
     */
    disable: function() {
        "use strict";

        $("body").addClass("is-subscriber");
        //SITE.Marketing.HeroOffer.init();

        // Set Cookie
        Cookies.set('sg-is-subscriber', true, { expires: 365 });
    },

    /**
     * Force Disable All Marketing
     *
     * Used when we want to close all active marketing widgets.
     *
     * @return mixed
     */
    forceDisable: function() {
        "use strict";

        // Close all known marketing widgets
        //this.WelcomeMat.close();
        //this.HeaderBar.hide();
    },

    /**
     * Enable Marketing Widgets
     * -------------------------
     * @return {[type]} [description]
     */
    enable: function() {
        "use strict";

        Cookies.remove('sg-is-subscriber');
        $("body").removeClass("is-subscriber");
    },


    /**
     * Check if we are ready to trigger a widget
     * -----------------------------------------
     * @return {[type]} [description]
     */
    yesWeCan: function() {
        "use strict";

        // Is Marketing Enabled?
        if (!SITE.Marketing.isEnabled()) return false;

        // Check if anything else is showing
        if (SITE.Marketing.activeNow !== "") return false;

        // If not....
        return true;

    },


    /**
     * Welcome Mat
     * ------------
     * @type {Object}
     */

    /*WelcomeMat: {

        shown: false, // Also saved to cookie "sg-welcome-mat-shown"

        init: function() {
            "use strict";

            // Check if Shown
            if (Cookies.get('sg-welcome-mat-shown') === "true") {
                SITE.Marketing.WelcomeMat.shown = true;
            }

            // Show on first visit for Caresprout & Growth Everywhere
            if(
                (typeof SiteCustom != 'undefined' && SiteCustom.Settings.property == 'caresprout') || 
                (typeof SITE.Settings != 'undefined' && SITE.Settings.property == 'growtheverywhere')
            ) {

                // Caresprout
                if(typeof SiteCustom != 'undefined' && SiteCustom.Settings.property == 'caresprout') {

                    // Has it been shown already?
                    if (!SITE.Marketing.WelcomeMat.shown) {

                        // Show Welcome Mat
                        SITE.Marketing.WelcomeMat.trigger();

                        // Close on submit
                        SITE.Marketing.WelcomeMat.close();
                        
                    }

                }

                // Growth Everywhere
                if(typeof SITE.Settings != 'undefined' && SITE.Settings.property == 'growtheverywhere') {

                    // Has it been shown already?
                    if (!SITE.Marketing.WelcomeMat.shown) {

                        // Check for preconfigured
                        SITE.Marketing.WelcomeMat.preconfig();

                        // Show Welcome Mat
                        SITE.Marketing.WelcomeMat.trigger();

                        // Close on submit
                        SITE.Marketing.WelcomeMat.close();
                        
                    }

                }

            } else {

                // Is Marketing Enabled?
                // if ( SITE.Marketing.isEnabled() && (!$("body").hasClass("front-page")) ) {
                if ( SITE.Marketing.isEnabled() ) {

                    // If only exit pop is preferred, we skip it
                    if( ! SITE.Marketing.isOnlyExitPop()) {

                        // Did the visitor come from an email? If so then
                        // don't show them the welcome mat
                        if (!$("body").hasClass("came-from-email")) {

                            // Do not show it on first visit
                            //if( ! SITE.Marketing.isFirstVisit()) {

                                // Has it been shown already?
                                if (!SITE.Marketing.WelcomeMat.shown) {

                                    // Check for preconfigured
                                    SITE.Marketing.WelcomeMat.preconfig();

                                    // Show Welcome Mat
                                    SITE.Marketing.WelcomeMat.trigger();

                                    // Close on submit
                                    SITE.Marketing.WelcomeMat.close();
                                }

                            //}
                        }

                    }
                }

            }
        },

        preconfig: function() {
            "use strict";

            var mat, frm, el, config;

            console.log(SITE.PreConfig);

            if (typeof SITE.PreConfig.WelcomeMat !== "undefined") {

                config = SITE.PreConfig.WelcomeMat;
                mat = $("#welcomeMat");
                
                frm = mat.find("form");
                frm.data("drip-embedded-form", config.dripId);
                frm.attr("action", "https://www.getdrip.com/forms/" + config.dripId + "/submissions");

                if (typeof SITE.PreConfig.WelcomeMat.request !== "undefined") {
                    
                    el = mat.find("input[name='fields[request]']");
                    
                    if (el.length === 0) {
                    
                        el = $("<input type='hidden' name='fields[request]' value='" + SITE.PreConfig.WelcomeMat.request + "'>");
                        frm.append(el);
                    
                    } else {
                    
                        el.val(SITE.PreConfig.WelcomeMat.request);
                    
                    }
                }

                mat.find(".pre-header").text(config.preHeader);
                mat.find(".heading").text(config.heading);
            }
        },

        trigger: function() {
            "use strict";

            var el = $("#welcomeMat");

            el.addClass("active");
            SITE.Marketing.activeNow = "Welcome Mat";

            el.find("[data-dismiss]").click(function() {

                if(typeof SiteCustom != 'undefined' && SiteCustom.Settings.property == 'caresprout') {
                    // Do nothing, it's Caresprout
                } else {
                    if(SITE.Settings.property != 'growtheverywhere') {
                        SITE.Tracking.Conversions.track('Welcome Mat', 'dismiss');
                    }
                }

                el.slideUp( function() {
                    SITE.Marketing.activeNow = "";
                    el.remove();
                });

            });

            if(typeof SiteCustom != 'undefined' && SiteCustom.Settings.property == 'caresprout') {
                // Do nothing, it's Caresprout
            } else {
                if(SITE.Settings.property != 'growtheverywhere') {

                    // Record GA Event / Internal Event
                    SITE.Tracking.GA.recordEvent('Trigger', 'Welcome Mat', 'Triggered Welcome Mat');
                    SITE.Tracking.Conversions.track('Welcome Mat', 'show');
                    
                }
            }

            // Hide Intercom
            if (typeof Intercom !== 'undefined') Intercom('hide');

            // Set as shown
            SITE.Marketing.WelcomeMat.shown = true;
            Cookies.set('sg-welcome-mat-shown', true, { expires: 1 }); // Show Once Per Day
        },

        close: function() {
            "use strict";

            var elForm = $('.welcome-mat form');

            elForm.submit(function(e) {
                e.preventDefault();

                // Submit the form
                this.submit();

                // Close the modal
                $('.welcome-mat').removeClass('active');

                return true;
            });
        }
    },*/

    /**
     * [ExitPop description]
     * @type {Object}
     */
    /*ExitPop: {

        shown: false, // Also saved to cookie "sg-exit-pop-shown"
        scrollThreshold: 500,

        init: function() {
            "use strict";

            if ( SITE.Marketing.isEnabled() ) {

                // Check for preconfigured
                SITE.Marketing.ExitPop.preconfig();

                // Check if Shown
                if (Cookies.get('sg-exit-pop-shown') === "true") {
                    SITE.Marketing.ExitPop.shown = true;
                }
                
                // Detect Exit Intent
                if ( SITE.UI.viewport.touch === true ) {

                    // On touch devices use time trigger
                    window.setTimeout(function() {
                        SITE.Marketing.ExitPop.trigger('Time Delay (Touch Device)');
                    }, 25000);

                } else {

                    // On other devices use exit intent
                    $(document).mouseleave(function(e){

                        // Did mouse go to the top?
                        if (e.clientY < 0) {
                            
                            // Has the user scrolled sufficiently?
                            if (SITE.Marketing.ExitPop.scrollThreshold < SITE.UI.viewport.scrollTop ) {
                                SITE.Marketing.ExitPop.trigger('Exit Intent');
                            }
                        }

                    });
                }

                // Know when modal is on or off
                $('#exitPopModal')
                    .on('shown.bs.modal', function (e) {
                        
                        SITE.Marketing.ExitPop.shown = true;
                        Cookies.set('sg-exit-pop-shown', true, { expires: 1 }); // Show Once Per Day

                        SITE.Marketing.activeNow = "Exit Pop";
                        SITE.Tracking.Conversions.track('Exit Pop (Newsletter)', 'show');
                    
                    })
                    .on('hidden.bs.modal', function (e) {
                        SITE.Marketing.activeNow = "";
                        SITE.Tracking.Conversions.track('Exit Pop (Newsletter)', 'dismiss');
                    });

            }

        },

        preconfig: function() {
            "use strict";

            var exitPop, form, element, props;

            if (typeof SITE.PreConfig.ExitPop !== "undefined") {

                props = SITE.PreConfig.ExitPop;
                exitPop = $('#exitPopModal');
                form = exitPop.find('form');

                form.attr('action', 'https://www.getdrip.com/forms/' + props.dripId + '/submissions');
                form.attr('data-drip-embedded-form', props.dripId);
                exitPop.find('.modal-header').find('.h2').html(props.headline);
                exitPop.find('.modal-header').find('.subheading').html(props.subheading);
                exitPop.find('.modal-footer').find('.btn').html(props.button);
                exitPop.find('.modal-footer').find('.close-link').html(props.closeLink);

            }
        },

        trigger: function(triggerMethod) {
            "use strict";

            var c, el;

            // Can we show the widget?
            if (!SITE.Marketing.yesWeCan()) return false;

            // Has it been shown already?
            if (SITE.Marketing.ExitPop.shown === true) return false;

            // If we came this far, it means we can show popups
            
            // But first, we need to hide the header bar (if it's on)
            SITE.Marketing.HeaderBar.hide();

            if (SITE.Marketing.isOnlyExitPop()) {

                // Only Exit Pop for LinkedIn paid social
                el = $('#exitPopModal');
                el.find('form')
                    .attr('action', 'https://www.getdrip.com/forms/97177125/submissions')
                    .attr('data-drip-embedded-form', '97177125')
                    .attr('data-tracking', 'Triggered Exit Pop (LinkedIn Paid Social)')
                    .attr('data-drip-id', '97177125');

                el.find('.modal-header')
                    .find('.h2')
                        .html('<span style="font-size: 1.4rem;">Get Your Copy of The Ultimate Marketing Guide for</span><br><b>Online Educational Companies</b>')
                        .end()
                    .find('.subheading')
                        .hide();

                el.find('.modal-footer')
                    .find('button')
                        .html('Send me the free guide now!')
                        .end()
                    .find('.close-link').html('No thanks.');

                el.find("#epTags").val("Via Exit Pop (EDU)");
                el.find("#epRequest").val("guide");

                el.find()

                el.modal('show');
                SITE.Tracking.GA.recordEvent('Trigger', triggerMethod, 'Triggered Exit Pop (LinkedIn Paid Social)');

            } else if ($('body').hasClass('single-post')) {

                // Page is a blogpost. Get Course
                c = SITE.Marketing.Courses.getMatch(true);
                SITE.Marketing.ExitPop.showCourse(c);

                // Record GA Event
                SITE.Tracking.GA.recordEvent('Trigger', triggerMethod, 'Triggered Exit Pop (' + c.cat + ' course)');

            } else {

                if($('body').hasClass('ms-podcast')) {
                    SITE.Marketing.ExitGiveaway.init();
                    SITE.Tracking.GA.recordEvent('Trigger', triggerMethod, 'Triggered Exit Giveaway (Marketing School)');
                } else {
                    $('#exitPopModal').modal('show');
                    SITE.Tracking.GA.recordEvent('Trigger', triggerMethod, 'Triggered Exit Pop (Newsletter)');
                }

            }

            // Close on submit
            var elForm = $('#exitPopModal form');

            elForm.submit(function(e) {
                e.preventDefault();

                // Submit the form
                this.submit();

                // Close the modal
                setTimeout(function() {
                    $('#exitPopModal').modal('hide');
                }, 100);

                return true;
            });

        },

        showCourse: function(course) {
            "use strict";

            var el = $("#courseModal");

            // If header bar is on it needs to be hidden
            SITE.Marketing.HeaderBar.hide();

            $("#courseModalHeading").text(course.headline);
            $("#courseModalSubHead").text(course.description);
            $("#courseModalForm")
                .attr("data-drip-embedded-form", course.dripID.exitPop)
                .attr("action", "https://www.getdrip.com/forms/" + course.dripID.exitPop + "/submissions")
                .data("tracking", 'Exit Pop (' + course.cat + ' course)');
            
            el.addClass("active");

            SITE.Marketing.ExitPop.shown = true;
            Cookies.set('sg-exit-pop-shown', true, { expires: 1 }); // Show Once Per Day
            
            SITE.Tracking.Conversions.track('Exit Pop (' + course.cat + ' course)', 'show');

            el.find("[data-dismiss]").click(function() {
                el.removeClass("active");
                SITE.Marketing.activeNow = "";
                SITE.Tracking.Conversions.track('Exit Pop (' + course.cat + ' course)', 'dismiss');
            });

        }

    },*/

    /**
     * In-Post Dynamic CTA
     * -------------------
     * @type {Object}
     */
    /*InPostCta: {

        init: function() {
            "use strict";

            var html, c, a, p, ps;

            // Only enable for blog posts
            if (!$("body").hasClass("single-post")) return false;

            if (!SITE.Marketing.isEnabled()) return false;

            // Got this far, means we can show CTAs
            c = SITE.Marketing.Courses.getMatch(true);

            a = $("#inPostCtaLink");
            a.data('headline', c.headline);
            a.data('subheading', c.description);
            a.data('dripid', c.dripID.inPost);
            a.html(" &gt;&gt; " + c.headline + " &lt;&lt; ");

            p = $(document.createElement('p'));
            p.append(a);
            p.append("<br/>");
            p.append(c.description);

            ps = $(".entry-content p");
            p.insertAfter(ps.eq(5));


        }
    },*/

    /**
     * Email Courses
     * --------------
     * @type {Object}
     */
    /*Courses: {

        campaigns: [
            {
                cat:         "seo",
                headline:    "Get Our 11 Day SEO Course For Free",
                dripID:      {
                                inPost: 10104994,
                                exitPop: 76426057
                            },
                keywords:    "seo, search-engine-optimization, design, link-building, mobile",
                description: "Learn timeless SEO techniques used by leaders like Neil Patel and Derek Halpern."
            },
            {
                cat:        "ppc",
                headline:   "Get Our 5 Day PPC Course For Free",
                dripID:     {
                                inPost: 68308203,
                                exitPop: 16038476
                            },
                keywords:    "pay-per-click, ppc, facebook-ads, twitter-ads, mobile-ads, youtube-ads",
                description: "Learn how to grow your business using paid advertising (like YouTube and Facebook ads)."
            },
            {
                cat:        "growth-hacking",
                headline:   "Get Our 13 Day Growth Hacking Course For Free",
                dripID:     {
                                inPost: 44670290,
                                exitPop: 46958828
                            },
                keywords:   "conversions, analytics, business, productivity, growth",
                description:"Learn from the top growth experts in the world on how to scale your business."
            },
            {
                cat:        "content-marketing",
                headline:   "Get Our 7 Day Content Marketing Course For Free",
                dripID:     {
                                inPost: 59411096,
                                exitPop: 18522554
                            },
                keywords:    "content, marketing, blogging, copywriting, infographic",
                description: "Learn how to create content that elevates your traffic and revenues."
            }
        ],

        getMatch: function(ifNoMatchGetRandom) {
            "use strict";

            ifNoMatchGetRandom = ifNoMatchGetRandom || false;

            var url         = window.location.pathname,
                campaigns   = SITE.Marketing.Courses.campaigns,
                count       = campaigns.length,
                cat         = false,
                i, x, arr, cta;

            // Identify Page Category
            for (i = 0; i < count; i++) {
                arr = campaigns[i].keywords.split(',');
                for (x = 0; x < arr.length; x++) {
                    if (url.indexOf($.trim(arr[x])) !== -1) {
                        cat = campaigns[i];
                        break;
                    }
                }
            }

            // If no cat, just set first one for now
            if (cat === false && ifNoMatchGetRandom === true) {
                cat = campaigns[0];
            }

            return cat;
        }

    },
    */

    /*HeroOffer: {

        init: function() {
            "use strict";
            
            var b = $('body');

            if (b.hasClass('front-page') && b.hasClass("is-subscriber")) {

                $('#heroOffer').hide();
                $('#defHeroCta').show();
                
            }
        }
    },
    */

    /*HeaderBar: {

        tracked: false,

        init: function() {
            "use strict";

            var bar = $("#headerOptInBar");
            
            if (!$("body").hasClass("front-page")) {
                
                $(window).scroll(function() {

                    // Enable for all but mobile
                    if (SITE.UI.viewport.mode !== "xs") {

                        // Only enable after user scrolls down
                        if ($(window).scrollTop() > 500) {
                            if (bar.is(":hidden")) {
                                if (SITE.Marketing.yesWeCan()) {
                                    bar.slideDown("fast");
                                    
                                    // Record GA Event
                                    if (!SITE.Marketing.HeaderBar.tracked) {
                                        SITE.Tracking.GA.recordEvent('Trigger', 'Header Bar', 'Triggered Header Bar');
                                        SITE.Tracking.Conversions.track('Header Bar', 'show');
                                        SITE.Marketing.HeaderBar.tracked = true;
                                    }
                                }
                            }
                        } else {
                            if (!bar.is(":hidden")) {
                                $("#headerOptInBar").hide();
                            }
                        }
                    }
                });

                bar.find('.close').click(function() {
                    SITE.Tracking.Conversions.track('Header Bar', 'dismiss');
                    bar.fadeOut(function() {
                        bar.remove();
                    });
                });
            }
        },

        hide: function() {
            "use strict";

            $("#headerOptInBar").hide();
        }
    },*/

    /**
     * Popup asking for phone number
     * -----------------------------
     *
     * Inspired by www.callpage.io
     * @type {Object}
     */
    /*CallPop: {

        config: {
            country: 'US', // Show only for US Visitors
            interval: 60000 // 1 minute
        },

        init: function() {
            "use strict";

            var b = $("body"), 
                country;

            // Don't show if already shown today. 
            if (Cookies.get("sg-phone-pop-shown") === "true") return false;

            // If only exit pop is preferred, we skip it
            if(SITE.Marketing.isOnlyExitPop()) {
                return false;
            }

            // Shown only on service pages
            if (b.hasClass("service-page")) {

                SITE.Utils.setVisitorCountry();

                // Check if visitor is from the US
                country = Cookies.get('sg-country');

                if (country === 'US') {
                    SITE.Marketing.CallPop.setTrigger();
                }
            }

            // Record Conversions
            $("#phoneCallModal")
                .on('shown.bs.modal', function (e) {
                    SITE.Marketing.activeNow = "Phone Modal";
                    SITE.Tracking.Conversions.track('Phone Call Popup', 'show');
                    Cookies.set('sg-phone-pop-shown', true, { expires: 1 }); // Show Once Per Day
                })
                .on('hidden.bs.modal', function (e) {
                    SITE.Marketing.activeNow = "";
                    SITE.Tracking.Conversions.track('Phone Call Popup', 'dismiss');
                });
        },

        setTrigger: function() {
            "use strict";

            // Time trigger
            window.setTimeout(function() {

                $("#phoneCallModal").modal("show");

                // Close on submit
                var elForm = $('#phoneCallModal form');

                elForm.submit(function(e) {
                    e.preventDefault();

                    // Submit the form
                    this.submit();

                    // Close the modal
                    setTimeout(function() {
                        $('#phoneCallModal').modal('hide');
                    }, 100);

                    return true;
                });
                
            }, this.config.interval);

        }

    }*/

};

// This is an exception for Caresprout since I had no access
// to JS source files, had to create a custom JS file.
if(typeof SiteCustom != 'undefined') {
    SITE.Marketing.init();
}

/* End of marketing.js */